import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TrackingCalledSectionDashboardEnum} from '../../enums/tracking-called-section-dashboard.enum';
import {ITrackingService} from '../../services/tracking.service.interface';

@Component({
    selector: 'app-products-box',
    templateUrl: './products-box.component.html',
    styleUrls: ['./products-box.component.scss']
})

export class ProductsBoxComponent implements OnInit {

    model: any = {
        searchTerm: '',
    };

    public TrackingCalledSectionDashboardEnum = TrackingCalledSectionDashboardEnum;

    constructor(
        private router: Router,
        private trackingService: ITrackingService
    ) {
    }

    ngOnInit() {
        console.log('ProductsBoxComponent init');
    }

    search(): void {
        const searchTerm = this.model.searchTerm;
        this.onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_PRODUCT_SEARCH);
        if (searchTerm) {
            this.router.navigate(['/products', 'product-finder', 'search', searchTerm]);
        }
    }

    onHtmlItemClicked(itemId?: TrackingCalledSectionDashboardEnum) {
        const trackingId = TrackingCalledSectionDashboardEnum[itemId];

        // console.log('[H]', trackingId);
        if (trackingId) {
            try {
                this.trackingService.createTrackingEvent(trackingId, new Date());
            } catch (e) {
                console.error(e);
            }
        } else {
            console.warn('unknown tracking id', itemId);
        }
    }
}
